import { render, staticRenderFns } from "./MarketingFooter.vue?vue&type=template&id=73da1c59&scoped=true&"
import script from "./MarketingFooter.vue?vue&type=script&lang=ts&"
export * from "./MarketingFooter.vue?vue&type=script&lang=ts&"
import style0 from "./MarketingFooter.vue?vue&type=style&index=0&id=73da1c59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73da1c59",
  null
  
)

export default component.exports